// extracted by mini-css-extract-plugin
export default {"memoaction":"memoaction_memoaction__UjZhS","time":"memoaction_time__guKer","anchorButtonActions":"memoaction_anchorButtonActions__bdeLN"};